import React from "react"
import { FieldTemplateProps } from "@rjsf/core";
import { Form, Message } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../hooks/useSchemaTranslation";


export const FieldError: React.FC<FieldTemplateProps> = (props) => {
    const { t } = useSchemaTranslation();
    const label = props.label || props.schema.title;
    const widget = props.uiSchema["ui:widget"];
    return (
        <Form.Field required={props.required} >
            {label && <label>{t(label)} </label>}
            {widget ? (
                <Message content={`Unconfigured widget ${widget}`} />
            ) : <Message content="Failed to render field" negative />}
        </Form.Field>
    );
};